export const environment = {
  base_url: 'https://dev.stbl1.link',
  allowed_origin: 'https://dev.app.stbl1.link',
  dataLimit: '20',
  production: false,
};
